module.exports = __webpack_public_path__ + "009c8ef966d540733b2733ee4aada4e4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/unimpressed-24.png
// module id = 2357
// module chunks = 0